import { Grid, Stack, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import QuizIcon from "../../../../../assets/icons/quiz-icon.svg";
import { StyledPaper } from "../../../../../customComponents/styled/styledPaper";
import MathContent from "../../../../customComponents/MathContent";
import {
  LessonPlanLabel,
  LessonPlanValue,
} from "../../../../../customComponents/styled/StyledTypgraphies";
import { FilledButton } from "../../../../../customComponents/styled/styledButtons";
import { useLocation } from "react-router-dom";
import { parseUTC } from "../../../../../helpers/dateUtils";


const ExpandQuizzes = () => {
  const location = useLocation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const { cardData } = location.state || {};

  if (!cardData) {
    return (
      <Box>
        <Typography variant="h6">Quiz not found</Typography>
      </Box>
    );
  }

  const formatDate = (dateString) => {
    const date = parseUTC(dateString);

    if (!date) {
      throw new Error("Invalid date string");
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  return (
    <Box>
      <Stack gap={4} key={cardData.id}>
        <StyledPaper sx={{ py: 4, px: 8 }}>
          <Stack
            direction="row"
            alignItems="center"
            alignContent="center"
            gap={1}
          >
            <img src={QuizIcon} style={{ height: "24px", width: "24px" }} />
            <Typography
              sx={{
                color: "1E1E1E",
                fontSize: "23.813px",
                fontWeight: 700,
                textTransform: "capitalize",
              }}
            >
              {cardData?.questions[0]?.topic} Quiz
            </Typography>
          </Stack>
          <Box
            mt={4}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              rowGap: 4,
              ">*": {
                width: "33%",
              },
            }}
          >
            <Stack>
              <LessonPlanLabel>Date</LessonPlanLabel>
              <LessonPlanValue>
                {formatDate(cardData.updated_at)}
              </LessonPlanValue>
            </Stack>
            <Stack>
              <LessonPlanLabel>Topic</LessonPlanLabel>
              <LessonPlanValue>{cardData?.questions[0]?.topic}</LessonPlanValue>
            </Stack>
            <Stack>
              <LessonPlanLabel>Subject</LessonPlanLabel>
              <LessonPlanValue>{cardData.subject}</LessonPlanValue>
            </Stack>
            <Stack>
              <LessonPlanLabel>Class</LessonPlanLabel>
              <LessonPlanValue>{cardData.level}</LessonPlanValue>
            </Stack>
            <Stack>
              <LessonPlanLabel>Questions</LessonPlanLabel>
              <LessonPlanValue>{cardData?.questions.length}</LessonPlanValue>
            </Stack>
            <Stack>
              <LessonPlanLabel>Duration</LessonPlanLabel>
              <LessonPlanValue>{cardData.duration} mins</LessonPlanValue>
            </Stack>
          </Box>
        </StyledPaper>
        {cardData?.questions.map((question, i) => (
          <StyledPaper
            sx={{
              py: 4,
              px: 8,
              display: "flex",
              alignItems: "flex-start",
              gap: 6,
            }}
            key={question.id}
          >
            <Box
              sx={{
                bgcolor: "primary.main",
                color: "white",
                width: "fit-content",
                px: "20px",
                py: "15px",
                borderRadius: "72px",
                fontWeight: 700,
                fontSize: "20px",
              }}
            >
              {i + 1}
            </Box>
            <Grid container rowSpacing={3} columnSpacing={4}>
              <Grid item xs={12}>
                <Typography sx={{ p: 1, fontSize: "16px" }}>
                  <MathContent html={question.body} />
                </Typography>
              </Grid>
              {question.options.map((option) => (
                <Grid key={option.id} item xs={12} md={6}>
                  <Box
                    sx={{
                      border: "1px solid",
                      borderColor: option.is_answer ? "#27AE60" : "#E02424",
                      borderRadius: "14px",
                      padding: "17px",
                      fontWeight: 500,
                      color: option.is_answer ? "#27AE60" : theme.palette.text.primary,
                    }}
                  >
                    <MathContent html={option.body} />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </StyledPaper>
        ))}
        <Stack direction="row" gap={4} sx={{ justifyContent: "center", my: 2 }}>
          <FilledButton
            className="outlined"
            sx={{ fontWeight: 500, width: "179px" }}
          >
            Share quiz
          </FilledButton>
          <FilledButton sx={{ fontWeight: 500, width: "179px" }}>
            Delete quiz
          </FilledButton>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ExpandQuizzes;
